import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useCompanies, useCompany } from '../../../components/contexts/CompanyContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import FinderVehicleList from './FinderVehicleList';
import ImportLtaButton from './ImportLtaButton';
import SyncFinderVehicleButton from './SyncFinderVehicleButton';

const FinderVehicleListPage = () => {
    const { t } = useTranslation(['finderVehicleList']);

    const company = useCompany(true);
    const companies = useCompanies(true);

    const [modules, modulesHasLta] = useMemo(() => {
        const foundModules =
            company?.modules?.filter(module => module.__typename === 'FinderVehicleManagementModule') ?? [];

        return [
            foundModules,
            foundModules?.some(
                module => module.__typename === 'FinderVehicleManagementModule' && module.setting.allowLTA
            ),
        ];
    }, [company?.modules]);

    if (!company && !companies?.length) {
        return <NoItemResult subTitle={t('finderVehicleList:noCompanySelected')} />;
    }

    return (
        <ConsolePageWithHeader
            extra={
                company &&
                hasPermissions(company.permissions, [permissionKind.manageFinderVehicles]) && [
                    modulesHasLta && <ImportLtaButton key="importLta" availableModules={modules} />,
                    <SyncFinderVehicleButton key="syncFinderVehicle" companyId={company?.id} />,
                ]
            }
            title={t('finderVehicleList:title')}
        >
            <FinderVehicleList companies={companies} company={company} modulesHasLta={modulesHasLta} />
        </ConsolePageWithHeader>
    );
};

export default FinderVehicleListPage;
